import axios from "axios";
import Swal from "sweetalert2";

const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("MagexApp.cart");
  window.location.replace("/");
};

const request = async function (options) {
  let client = axios.create({
    baseURL: process.env.REACT_APP_SERVER_API,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  });

  const onSuccess = function (response) {
    return response;
  };

  const onError = function (error) {
    console.error("Request Failed:", error.config);

    if (error.response) {
      // Request was made but server responded with something
      // other than 2xx
      if (error.response.status === 401) {
        Swal.fire({
          text: `Your session has been expired or you have no permission for this data, please login in again!`,
          icon: "error",
        }).then(() => {
          // logout();
        });
      }
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
      console.error("Headers:", error.response.headers);
    } else {
      // Something else happened while setting up the request
      // triggered the error
      console.error("Error Message:", error.message);
    }

    return Promise.reject(error);
  };

  return client(options).then(onSuccess).catch(onError);
};

export default request;
